import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLabel = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.33268 12.1673C2.01185 12.1673 1.7372 12.0531 1.50872 11.8246C1.28025 11.5961 1.16602 11.3215 1.16602 11.0007V4.00065C1.16602 3.67982 1.28025 3.40516 1.50872 3.17669C1.7372 2.94822 2.01185 2.83398 2.33268 2.83398H8.74935C8.93407 2.83398 9.10907 2.8753 9.27435 2.95794C9.43963 3.04058 9.57574 3.15482 9.68268 3.30065L12.8327 7.50065L9.68268 11.7007C9.57574 11.8465 9.43963 11.9607 9.27435 12.0434C9.10907 12.126 8.93407 12.1673 8.74935 12.1673H2.33268Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgLabel);
export default ForwardRef;
